"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientInterceptors = void 0;
const axios_1 = __importDefault(require("axios"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const common_1 = require("@epic-core/common");
const noop = () => { };
function clientInterceptors({ loginFn, logoutFn } = {}) {
    axios_1.default.interceptors.request.use((config) => {
        if (!config.noHeaderMods) {
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
        }
        return config;
    });
    axios_1.default.interceptors.response.use(response => {
        return response;
    }, err => {
        if (err.response && err.response.status === 401) {
            const { message } = err.response.data;
            const returnUrl = window_or_global_1.default.location.pathname || '/';
            if (message === 'epic.common.sso.missing_bearer_token') {
                if (loginFn && typeof loginFn === 'function') {
                    loginFn(returnUrl, err);
                }
                else {
                    const loginParams = { state: returnUrl };
                    const loginUrl = `${window_or_global_1.default.appContext || ''}/login?${common_1.processParams(loginParams)}`;
                    window_or_global_1.default.location.href = loginUrl;
                }
            }
            else if (message === 'epic.common.sso.session_invalid') {
                if (logoutFn && typeof logoutFn === 'function') {
                    logoutFn(returnUrl, err);
                }
                else {
                    const logoutParams = { state: returnUrl };
                    const logoutUrl = `${window_or_global_1.default.appContext || ''}/logout?${common_1.processParams(logoutParams)}`;
                    window_or_global_1.default.location.href = logoutUrl;
                }
            }
            return new Promise(noop);
        }
        return Promise.reject(err);
    });
}
exports.clientInterceptors = clientInterceptors;
//# sourceMappingURL=clientInterceptors.js.map